import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { Icons, IconProps } from './IconsRes';
import { getIconClasses } from '@/Static/IconUtils';

export const DocumentIcon = ({ id, size = 'small', onClick, disabled, dataAttributes }: IconProps) => {
  return (
    <img
      id={id}
      src={Icons.Doc}
      alt="img"
      className={cn(styles.icon, getIconClasses(size, disabled))}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
      {...dataAttributes}
    />
  );
};
